import { choose } from '../../utils/platform';
import ReminderFormDesktop from './ReminderForm.desktop';
import ReminderFormMobile from './ReminderForm.mobile';

// Platform chooser: the APK renders the mobile variant, any browser the desktop one.
export default choose(ReminderFormDesktop, ReminderFormMobile);
